import { useEffect, useState } from "react";
import axios from "axios";
import { API_HOST } from "../../constants";
import BbsList from "./BbsList";
import Pagination from "../ui/Pagination";
import LoadingAnime from "../Common/LoadingAnime";
import EmptyState from "../ui/EmptyState";

const tagLabel = (name) => (name ? `#${name}` : "");

function Tag() {
  const [query, setQuery] = useState("");
  const [tags, setTags] = useState([]);
  const [selectedTag, setSelectedTag] = useState("");
  const [posts, setPosts] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loadingTags, setLoadingTags] = useState(false);
  const [loadingPosts, setLoadingPosts] = useState(false);

  useEffect(() => {
    setLoadingTags(true);
    axios
      .get(`${API_HOST}/api/tags/`, { params: { query, order: "latest" } })
      .then((response) => setTags(response.data))
      .catch(() => setTags([]))
      .finally(() => setLoadingTags(false));
  }, [query]);

  useEffect(() => {
    if (!selectedTag) {
      setPosts([]);
      setLoadingPosts(false);
      return;
    }
    setLoadingPosts(true);
    axios
      .get(`${API_HOST}/api/tags/${encodeURIComponent(selectedTag)}/bbs/`, { params: { page } })
      .then((response) => {
        setPosts(response.data.results || []);
        setTotalPages(response.data.total_pages || 1);
      })
      .catch(() => {
        setPosts([]);
        setTotalPages(1);
      })
      .finally(() => setLoadingPosts(false));
  }, [selectedTag, page]);

  if (loadingTags) {
    return <LoadingAnime label="태그 정보를 불러오는 중..." />;
  }

  return (
    <div className="space-y-6">
      <section className="glass-card p-6">
        <h2 className="text-2xl font-semibold text-white">태그 탐색</h2>
        <p className="mt-1 text-sm text-ink-200">#태그를 클릭하면 최신 게시글을 확인할 수 있습니다.</p>
        <input
          className="soft-input mt-4"
          value={query}
          onChange={(event) => setQuery(event.target.value)}
          placeholder="#검색할 태그를 입력하세요"
        />
      </section>

      <section className="glass-card p-6">
        <div className="flex flex-wrap gap-2">
          {tags.length ? (
            tags.map((tag) => (
              <button
                key={tag.id}
                type="button"
                onClick={() => {
                  setSelectedTag(tag.name);
                  setPage(1);
                }}
                className={`chip ${selectedTag === tag.name ? "chip-active" : ""}`}
              >
                {tagLabel(tag.name)} {tag.usage_count ? `· ${tag.usage_count}` : ""}
              </button>
            ))
          ) : (
            <span className="text-sm text-ink-200">등록된 태그가 없습니다.</span>
          )}
        </div>
      </section>

      {selectedTag && (
        <section className="glass-card p-6">
          <div className="flex items-center justify-between">
            <div>
              <h3 className="text-lg font-semibold text-white">{tagLabel(selectedTag)} 게시글</h3>
              <p className="text-xs text-ink-200">최신순으로 표시됩니다.</p>
            </div>
          </div>
          <div className="mt-4">
            {loadingPosts ? (
              <LoadingAnime label="태그 게시글을 불러오는 중..." />
            ) : posts.length ? (
              <BbsList posts={posts} moduleName={""} currentPage={page} selectedCategory={""} />
            ) : (
              <EmptyState title="게시글이 없습니다" description="다른 태그를 선택해보세요." />
            )}
          </div>
          <div className="mt-4">
            <Pagination totalPages={totalPages} currentPage={page} onPageChange={setPage} />
          </div>
        </section>
      )}
    </div>
  );
}

export default Tag;
